import React from 'react';
import { Box } from '@mui/material';
import parse from 'html-react-parser';

interface EConsentWrapperProps {
    content: string;
}

const EConsentWrapper: React.FC<EConsentWrapperProps> = ({ content }) => {
    return (
        <Box
            sx={{
                width: '100%',
                fontSize: '14px',
                p: 0,
                a: {
                    // @ts-ignore has primary
                    color: (theme) => `${theme.palette.common.primary} !important`,
                },
            }}
            className='ql-editor'
            data-testid='e-consent-wrapper'
        >
            {parse(content)}
        </Box>
    );
};

export default EConsentWrapper;
